(ns splash.ui.lender-portal.components.zoom-pan-pinch
  (:require
    ["react-zoom-pan-pinch" :as reactZoomPanPinch]
    [reagent.core :as r]))

(def transform-wrapper (r/adapt-react-class reactZoomPanPinch/TransformWrapper))

(def transform-component (r/adapt-react-class reactZoomPanPinch/TransformComponent))
